import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { BRAND } from "@/constants/brand";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (user) {
      const dest = user.role_level === "staff" ? "/admin/cash" : "/admin";
      nav(dest, { replace: true });
    }
  }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(identifier.trim(), password);
    setLoading(false);
    if (r.ok) {
      toast.success("Welcome back.");
      const dest = r.user?.role_level === "staff" ? "/admin/cash" : "/admin";
      nav(dest, { replace: true });
    } else {
      toast.error(r.error || "Login failed");
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-brand-charcoal text-brand-cream p-12">
        <Link to="/" className="flex items-center gap-3" data-testid="admin-login-home">
          <img src={BRAND.logoUrl} alt="Pop Panda" className="h-10 w-10 bg-brand-cream rounded-full p-1.5" />
          <div className="font-display text-2xl">Pop Panda</div>
        </Link>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-brand-yellow">Admin Console</div>
          <h2 className="font-display text-5xl mt-3 leading-none">The freezer<br />behind the brand.</h2>
          <p className="mt-5 text-brand-cream/70 max-w-md">Cash &amp; Digital Control, products, flavours, prototypes, members and more.</p>
        </div>
        <div className="text-xs text-brand-cream/40">© {new Date().getFullYear()} The Pop Panda</div>
      </div>

      <div className="grid place-items-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-6" data-testid="admin-login-form">
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Sign in</div>
            <h1 className="editorial-h1 text-5xl mt-2">Admin Console</h1>
            <p className="mt-2 text-sm text-brand-charcoal/60">Enter your <strong>Login ID</strong> or email.</p>
          </div>
          <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Login ID or Email</label><input data-testid="login-identifier" className="pp-input" type="text" required autoComplete="username" value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder="POPPANDA or admin@poppanda.in" /></div>
          <div><label className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Password</label><input data-testid="login-password" className="pp-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          <button data-testid="login-submit" disabled={loading} className="btn-pill btn-dark w-full disabled:opacity-50">{loading ? "Signing in…" : "Sign in"}</button>
          <Link to="/" className="block text-xs text-brand-charcoal/55 text-center" data-testid="admin-login-back">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
